/* eslint-disable @typescript-eslint/no-empty-function */
import Axios, {
	AxiosRequestConfig,
	AxiosResponse,
} from 'axios';

export class HttpService {
	protected static axios = Axios.create();

	public static get<R>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return this.axios.get(url, config)
			.then((response) => response.data);
	}

	public static delete<R>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return this.axios.delete(url, config)
			.then((response) => response.data);
	}

	public static patch<R, D = void>(url: string, data?: D, config?: AxiosRequestConfig): Promise<R> {
		return this.axios.patch<D, AxiosResponse<R>>(url, data, config)
			.then((response) => response.data);
	}

	public static post<R, D = void>(url: string, data?: D, config?: AxiosRequestConfig): Promise<R> {
		return this.axios.post<D, AxiosResponse<R>>(url, data, config)
			.then((response) => response.data);
	}

	public static put<R, D = void>(url: string, data?: D, config?: AxiosRequestConfig): Promise<R> {
		return this.axios.put<D, AxiosResponse<R>>(url, data, config)
			.then((response) => response.data);
	}

	protected static setAxiosInstance(config?: AxiosRequestConfig): void {
		this.axios = Axios.create(config);
	}
}
